import { reportEvent } from '@/app/utils';
import { POPUP_NAMES } from './constants';
import type { CreditV1Coupon } from './types';

/**
 * 开屏弹窗按钮点击埋点：统一上报 `home_popup_click`，`popup_name` 取自 POPUP_NAMES。
 *
 * 新增开屏弹窗时，在 constants.ts 的 POPUP_NAMES 登记名字后，
 * 在弹窗 CTA 按钮点击处调用本函数即可。
 */
export const reportHomePopupClick = (dialogKey: string) => {
  const popupName = POPUP_NAMES[dialogKey];
  if (!popupName) return;
  reportEvent('home_popup_click', { popup_name: popupName });
};

export type CouponDiscountInfo =
  | { kind: 'percentage'; value: number }
  | { kind: 'fixed'; amount: number }
  | { kind: 'name'; name: string };

/**
 * 提取优惠券折扣的结构化信息，供调用方按 locale 渲染
 * - percentage 80 → { kind: 'percentage', value: 80 }
 * - fixed 95 → { kind: 'fixed', amount: 95 }
 * - 其他 → { kind: 'name', name }
 */
export const getCouponDiscountInfo = (coupon: CreditV1Coupon): CouponDiscountInfo => {
  if (coupon.discount_value && coupon.discount_type === 'percentage') {
    return { kind: 'percentage', value: coupon.discount_value };
  }
  if (coupon.discount_value && coupon.discount_type === 'fixed') {
    return { kind: 'fixed', amount: coupon.discount_value };
  }
  return { kind: 'name', name: coupon.name ?? '' };
};

/** 是否在 2 天内到期 */
export const isExpiringSoon = (expiredAt: string | undefined, thresholdDays = 2): boolean => {
  if (!expiredAt) return false;
  const diff = new Date(expiredAt).getTime() - Date.now();
  return diff > 0 && diff < thresholdDays * 24 * 60 * 60 * 1000;
};
